<template>
    <div class="purchases-detail">
        <!-- 采购详情部分 -->
        <div class="detail-section">
            <div class="section-title flex-center">
                <div>
                    <span class="title-icon">|</span>
                    <span class="title-text">采购详情</span>
                </div>
                <el-button type="text" @click="goBack" class="back-btn">返回</el-button>

            </div>
            <div class="detail-content">
                <div class="purchase-info">
                    <div class="info-item">
                        <span class="info-label">采购单号：</span>
                        <span class="info-value">{{ purchaseDetail.order_sn }}</span>
                    </div>
                    <div class="status-section" v-if="purchaseDetail.status == '1'">
                        <div class="status-section-box">
                            <span class="status-tag">一轮比价</span>
                            <span class="countdown">在 {{ purchaseDetail.query_end_date }} 结束</span>
                        </div>
                        <span class="status-desc">等待商家报价</span>
                    </div>

                    <div class="status-section" v-if="purchaseDetail.status == '2'">
                        <div class="status-section-box">
                            <span class="status-tag">一轮询价</span>
                            <span class="countdown">在 {{ purchaseDetail.query_end_date }} 结束</span>
                        </div>
                        <span class="status-desc">挑选合适的商家</span>
                    </div>

                    <div class="status-section" v-if="purchaseDetail.status == '3'">
                        <div class="status-section-box">
                            <span class="status-tag">二轮比价</span>
                            <span class="countdown">在 {{ purchaseDetail.query_end_date }} 结束</span>
                        </div>
                        <span class="status-desc">挑选合适的商家</span>
                    </div>

                    <div class="status-section" v-if="purchaseDetail.status == '4'">
                        <div class="status-section-box">
                            <span class="status-tag">配载中</span>
                            <span class="countdown">在 {{ purchaseDetail.query_end_date }} 结束</span>
                        </div>
                        <span class="status-desc">等待商家发货</span>
                    </div>

                    <div class="status-section" v-if="purchaseDetail.status == '5'">
                        <div class="status-section-box">
                            <span class="status-tag">配载完成</span>
                        </div>
                        <span class="status-desc">等待商家发货</span>
                    </div>

                    <div class="status-section" v-if="purchaseDetail.status == '6'">
                        <div class="status-section-box">
                            <span class="status-tag">运输中</span>
                        </div>
                    </div>

                    <div class="status-section" v-if="purchaseDetail.status == '7'">
                        <div class="status-section-box">
                            <span class="status-tag">待收货</span>
                        </div>
                        <span class="status-desc" style="color:#286CED;">请前往搏亿购APP内确认收货</span>
                    </div>

                    <div class="status-section" v-if="purchaseDetail.status == '8'">
                        <div class="status-section-box">
                            <span class="status-tag">待结算</span>
                        </div>
                        <span class="status-desc">请在规定的周期内结算</span>
                    </div>


                    <div class="status-section" v-if="purchaseDetail.status == '9'">
                        <div class="status-section-box">
                            <span class="status-tag">已完成</span>
                        </div>
                        <span class="status-desc">您的采购已完成</span>
                    </div>

                    <div class="status-section" v-if="purchaseDetail.status == '-1'">
                        <div class="status-section-box">
                            <span class="status-tag">已取消</span>
                        </div>
                        <span class="status-desc">您的订单已取消</span>
                    </div>
                    <div class="action-buttons">
                        <el-button type="default" size="small" class="end-purchase" v-if="purchaseDetail.status == '-1'"
                            @click="handleDeleteOrder(purchaseDetail)">删除</el-button>
                        <el-button type="default" size="small" class="end-purchase"
                            v-if="purchaseDetail.status == '1' || purchaseDetail.status == '2' || purchaseDetail.status == '3' || purchaseDetail.status == '4'"
                            @click="handleCaigouOrder(purchaseDetail)">结束采购</el-button>
                        <el-button type="primary" size="small" class="edit-purchase"
                            @click="handleEditOrder(purchaseDetail)"
                            v-if="purchaseDetail.status == '1' || purchaseDetail.status == '2' || purchaseDetail.status == '3'">修改采购</el-button>

                        <el-button type="default" size="small" class="end-purchase"
                            v-if="purchaseDetail.status == '9' && purchaseDetail.is_invoice == 0"
                            @click="applyInvoice(purchaseDetail)">申请开票</el-button>

                        <el-button type="primary" size="small" class="edit-purchase"
                            @click="handleEditOrder(purchaseDetail, 1)"
                            v-if="purchaseDetail.status == '9'">再来一单</el-button>

                    </div>

                    <!-- 配载延迟申请 -->
                    <div class="loading-delay-section"
                        v-if="purchaseDetail.status == '4' && purchaseDetail.is_delay == '1'">
                        <div class="delay-info">
                            <div class="delay-reason">
                                <p class="delay-reason-title">商家申请了配载延时{{ purchaseDetail.hour }}小时</p>
                                <p class="delay-reason-content">{{ purchaseDetail.delay_reason }}</p>
                            </div>
                            <div class="delay-actions">
                                <el-button type="default" size="small" class="reject-delay"
                                    @click="tongyiFn(2)">拒绝</el-button>
                                <el-button type="primary" size="small" class="accept-delay"
                                    @click="tongyiFn(1)">同意</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </div>

        <!-- 第二个板块：商家报价和底部操作 -->
        <div class="purchases-quotation-section" v-if="purchaseDetail.status < '4'">
            <!-- 商家报价部分 -->
            <div class="quotation-section">
                <div class="section-title">
                    <span class="title-icon">|</span>
                    <span class="title-text">商家报价 ({{ quotations.length || 0 }})</span>
                    <div class="sort-options">
                        <span class="sort-item" :class="{ 'active': sort == '2' }" @click="changeSort('2')">距离最近</span>
                        <span class="sort-item" :class="{ 'active': sort == '1' }" @click="changeSort('1')">报价最低</span>
                    </div>
                </div>
                <div class="quotation-table">
                    <el-table :data="quotations" style="width: 100%" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column label="序号" width="80">
                            <template slot-scope="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="store_name" label="店铺名称" width="180"></el-table-column>
                        <el-table-column prop="fahuodi" label="发货地" width="150"></el-table-column>
                        <el-table-column label="距离 (km)" width="120">
                            <template slot-scope="scope">{{ scope.row.distance_km }}</template>
                        </el-table-column>
                        <el-table-column label="综合报价 (元)" width="150">
                            <template slot-scope="scope">{{ scope.row.total_amount }}</template>
                        </el-table-column>
                        <el-table-column label="运费 (元)" width="120">
                            <template slot-scope="scope">{{ scope.row.shipping_fee }}</template>
                        </el-table-column>
                        <el-table-column prop="create_time" label="报价时间" width="180"></el-table-column>
                        <el-table-column label="操作" width="100">
                            <template slot-scope="scope">
                                <a href="#" class="detail-link" @click="viewQuotationDetail(scope.row)">报价明细</a>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="table-note" v-if="purchaseDetail.status == '1' ||
                        purchaseDetail.status == '2'">
                        选择您满意的商家，进入一轮询价环节，未选择的商家将被淘汰~
                    </div>

                    <div class="table-note" v-if="purchaseDetail.status == '3'">
                        选择一个您满意的商家，建立合作关系！
                    </div>
                </div>
            </div>

            <!-- 底部操作按钮 -->
            <div class="bottom-buttons">
                <el-button type="default" size="small" class="info-button" @click="openInvoiceDialog">查看开票信息</el-button>
                <el-button type="default" size="small" class="info-button"
                    @click="openReceiverInfoDialog">查看收货人信息</el-button>
                <el-button type="default" size="small" class="info-button" @click="openGoodsDialog">查看采购商品</el-button>
                <el-button type="default" size="small" class="info-button" @click="openTitleDialog">查看采购标题</el-button>
                <el-button type="primary" size="small" class="select-button"
                    v-if="purchaseDetail.status == '1' || purchaseDetail.status == '2'"
                    @click="selectMerchantForInquiry">选择商家询价</el-button>

                <el-button type="primary" size="small" class="select-button" v-if="purchaseDetail.status == '3'"
                    @click="openSelectMerchantDialog">选择商家合作</el-button>
            </div>
        </div>

        <!-- 第三个板块：合作商家 -->
        <div class="purchases-quotation-section" v-if="purchaseDetail.status >= '4'">
            <!-- 合作商家部分 -->
            <div class="quotation-section">
                <div class="section-title">
                    <span class="title-icon">|</span>
                    <span class="title-text">合作商家</span>
                </div>
                <div class="quotation-table">
                    <el-table :data="quotations" style="width: 100%">
                        <el-table-column label="序号" width="80">
                            <template slot-scope="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="store_name" label="店铺名称" width="180"></el-table-column>
                        <!-- <el-table-column prop="name" label="商品名称" width="180"></el-table-column> -->
                        <el-table-column prop="fahuodi" label="发货地" width="150"></el-table-column>
                        <el-table-column label="距离 (km)" width="120">
                            <template slot-scope="scope">{{ scope.row.distance_km }}</template>
                        </el-table-column>
                        <el-table-column label="综合报价 (元)" width="150">
                            <template slot-scope="scope">{{ scope.row.total_amount }}</template>
                        </el-table-column>
                        <el-table-column label="运费 (元)" width="120">
                            <template slot-scope="scope">{{ scope.row.shipping_fee }}</template>
                        </el-table-column>
                        <el-table-column prop="create_time" label="报价时间" width="180"></el-table-column>
                        <el-table-column prop="hezuo_yuanyin" label="合作原因" width="120"></el-table-column>
                        <el-table-column label="操作" width="100">
                            <template slot-scope="scope">
                                <a href="#" class="detail-link" @click="viewQuotationDetail(scope.row)"
                                    v-if="purchaseDetail.status == 4">报价明细</a>
                                <a href="#" class="detail-link" @click="viewQuotationDetail(scope.row)"
                                    v-if="purchaseDetail.status > 4">配载明细</a>

                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>

            <!-- 底部操作按钮 -->
            <div class="bottom-buttons">
                <el-button type="default" size="small" class="info-button" @click="openTitleDialog">查看采购标题</el-button>
                <el-button type="default" size="small" class="info-button" @click="openGoodsDialog">查看采购商品</el-button>
                <el-button type="default" size="small" class="info-button"
                    @click="openReceiverInfoDialog">查看收货人信息</el-button>
                <el-button type="default" size="small" class="info-button" @click="openInvoiceDialog">查看开票信息</el-button>
                <el-button type="default" size="small" class="info-button"
                    @click="openSecondComparisonDialog">查看二轮比价记录</el-button>
            </div>

            <!-- 签名和装货图片 -->
            <div class="signature-and-loading">
                <div class="signature-section">
                    <h3 class="section-title">
                        <span class="title-icon">|</span>
                        <span class="title-text">发货方签字</span>
                    </h3>
                    <div class="signature-list">
                        <div class="signature-item">
                            <div class="signature-image">
                                <!-- <img :src="purchaseDetail.logistics.merchant_sign" alt="商家签字"> -->
                                <el-image :src="purchaseDetail.logistics.merchant_sign" alt="商家签字"
                                    class="signature-image-el"
                                    :preview-src-list="[purchaseDetail.logistics.merchant_sign]" />
                            </div>
                            <div class="signature-label">商家签字</div>
                        </div>
                        <div class="signature-item">
                            <div class="signature-image">
                                <!-- <img :src="purchaseDetail.logistics.logistics_sign" alt="物流签字"> -->
                                <el-image :src="purchaseDetail.logistics.logistics_sign" alt="物流签字"
                                    class="signature-image-el"
                                    :preview-src-list="[purchaseDetail.logistics.logistics_sign]" />
                            </div>
                            <div class="signature-label">物流签字</div>
                        </div>
                    </div>
                </div>

                <div class="loading-photo-section">
                    <h3 class="section-title">
                        <span class="title-icon">|</span>
                        <span class="title-text">装车照片</span>
                    </h3>
                    <div class="loading-photo">
                        <el-image :src="item" v-for="(item, index) in purchaseDetail.logistics.upload_picture"
                            :key="'el-image-' + index" alt="装车照片" class="signature-image-el"
                            :preview-src-list="purchaseDetail.logistics.upload_picture" />
                    </div>
                </div>

                <div class="signature-section">
                    <h3 class="section-title">
                        <span class="title-icon">|</span>
                        <span class="title-text">收货方签字</span>
                    </h3>
                    <div class="signature-list">
                        <div class="signature-item">
                            <div class="signature-image">
                                <!-- <img :src="purchaseDetail.logistics.merchant_sign" alt="商家签字"> -->
                                <el-image :src="purchaseDetail.logistics.purchase_sign" alt="买家签字"
                                    class="signature-image-el"
                                    :preview-src-list="[purchaseDetail.logistics.purchase_sign]" />
                            </div>
                            <div class="signature-label">买家签字</div>
                        </div>
                        <div class="signature-item">
                            <div class="signature-image">
                                <!-- <img :src="purchaseDetail.logistics.logistics_sign" alt="物流签字"> -->
                                <el-image :src="purchaseDetail.logistics.logistics_buy_sign" alt="物流签字"
                                    class="signature-image-el"
                                    :preview-src-list="[purchaseDetail.logistics.logistics_buy_sign]" />
                            </div>
                            <div class="signature-label">物流签字</div>
                        </div>
                    </div>
                </div>


                <div class="loading-photo-section">
                    <h3 class="section-title">
                        <span class="title-icon">|</span>
                        <span class="title-text">开票信息</span>
                    </h3>
                    <div>
                        <div class="loading-photo">
                            <el-image :src="purchaseDetail.invoice_img" alt="开票照片" class="signature-image-el"
                                :preview-src-list="[purchaseDetail.invoice_img]" />
                        </div>
                        <div style="margin-top: 10px;text-align: left;" v-if="purchaseDetail.invoice_img">
                            <el-button type="primary" size="mini" @click="downloadInvoice">下载发票照片</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 签名和装货图片 -->

        </div>

        <!-- 配载明细弹窗 -->
        <el-dialog :title="purchaseDetail.status <= 4 ? '报价明细' : '配载明细'" :visible.sync="dialogVisible" width="800px"
            :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
            <div class="loading-detail-dialog">
                <el-table :data="currentQuotation ? currentQuotation.child : []" style="width: 100%">
                    <el-table-column prop="name" label="商品名称" width="230"></el-table-column>
                    <el-table-column label="报价单价" width="150">
                        <template slot-scope="scope">
                            {{ scope.row.price }}/{{ scope.row.unit || '' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="采购数量" width="100">
                        <template slot-scope="scope">
                            {{ scope.row.caigou_num }}
                        </template>
                    </el-table-column>
                    <el-table-column label="平台参考单价" width="150">
                        <template slot-scope="scope">
                            {{ scope.row.refer_price }}/{{ scope.row.unit || '' }}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="平台参考价" width="120">
                        <template slot-scope="scope">
                            {{ scope.row.platformTotal }}
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="certificate" label="产品证书" width="120">
                        <template slot-scope="scope">
                            <el-image :src="scope.row.product_certificate" alt="产品证书" class="certificate-image"
                                :preview-src-list="[scope.row.product_certificate]" />
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 合计行 -->
                <div class="total-row">
                    <div class="total-label">合计</div>
                    <div class="total-amount">{{ total_amount }}</div>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">关闭</el-button>
            </span>
        </el-dialog>

        <!-- 采购标题弹窗 -->
        <el-dialog title="采购标题" :visible.sync="titleDialogVisible" width="600px" :close-on-click-modal="false"
            :close-on-press-escape="false" :show-close="false">
            <div class="title-dialog-content">
                <div class="title-item">
                    <h3>{{ purchaseDetail.title || '' }}</h3>
                </div>
                <div class="requirement-item">
                    <p><strong>采购要求：</strong>{{ purchaseDetail.needs || '' }}</p>
                </div>
                <div class="settlement-item">
                    <p><strong>结算周期：</strong>{{ purchaseDetail.settle_type_name || '' }}</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeTitleDialog">关闭</el-button>
            </span>
        </el-dialog>

        <!-- 采购商品弹窗 -->
        <el-dialog title="采购商品" :visible.sync="goodsDialogVisible" width="800px" :close-on-click-modal="false"
            :close-on-press-escape="false" :show-close="false">
            <div class="goods-dialog-content">
                <el-table :data="purchaseGoods" style="width: 100%">
                    <el-table-column prop="name" label="商品名称" width="200"></el-table-column>
                    <el-table-column prop="num" label="采购数量" width="150"></el-table-column>
                    <el-table-column prop="error_range" label="可接受采购量误差" width="200"></el-table-column>
                    <el-table-column prop="refer_price" label="平台参考价" width="150"></el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeGoodsDialog">关闭</el-button>
            </span>
        </el-dialog>

        <!-- 收货人信息弹窗 -->
        <el-dialog title="收货人信息" :visible.sync="receiverInfoDialogVisible" width="600px" :close-on-click-modal="false"
            :close-on-press-escape="false" :show-close="true">
            <div class="receiver-info-content">
                <p><strong>收货人：</strong>{{ purchaseDetail.address_info.real_name || '' }} ({{
                    purchaseDetail.address_info.sex ==
                        '1' ? '先生' : '女士' }})</p>
                <p><strong>联系电话：</strong>{{ purchaseDetail.address_info.mobile || '' }}</p>
                <p><strong>收货地址：</strong>{{ purchaseDetail.address_info.detail || '' }}</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeReceiverInfoDialog">关闭</el-button>
            </span>
        </el-dialog>

        <!-- 开票信息弹窗 -->
        <el-dialog title="开票信息" :visible.sync="invoiceDialogVisible" width="700px" :close-on-click-modal="false"
            :close-on-press-escape="false" :show-close="true">
            <div class="invoice-info-content">
                <div class="invoice-header">
                    <p><strong>{{ purchaseDetail.invoice_info.username || '' }} <span class="invoice-type">{{
                        purchaseDetail.invoice_info.tax_number ? '公司' : '个人' }}</span></strong></p>
                    <p><strong>联系邮箱：</strong>{{ purchaseDetail.invoice_info.email || '' }}</p>
                    <p><strong>联系电话：</strong>{{ purchaseDetail.invoice_info.mobile || '' }}</p>
                    <p v-if="purchaseDetail.invoice_info.tax_number"><strong>公司税号：</strong>{{
                        purchaseDetail.invoice_info.tax_number || '' }}</p>
                </div>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeInvoiceDialog">关闭</el-button>
            </span>
        </el-dialog>

        <!-- 选择商家合作弹窗 -->
        <el-dialog title="选择商家合作" :visible.sync="selectMerchantDialogVisible" width="800px"
            :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true">
            <div class="select-merchant-dialog">
                <el-radio-group v-model="selectedMerchant" class="merchant-radio-group">
                    <el-radio v-for="merchant in quotations" :key="merchant.aid" :label="merchant"
                        class="merchant-radio">
                        <div class="merchant-item">
                            <div class="merchant-info">
                                <div class="merchant-name">{{ merchant.store_name }}</div>
                                <div class="merchant-details">
                                    <span>发货地：{{ merchant.fahuodi }}</span>
                                    <span>距离：{{ merchant.distance_km }}</span>
                                    <span>综合报价：{{ merchant.total_amount }}元</span>
                                    <span>运费：{{ merchant.shipping_fee }}元</span>
                                    <!-- <span>报价时间：{{ merchant.create_time }}</span> -->
                                </div>
                            </div>
                        </div>
                    </el-radio>
                </el-radio-group>
                <div v-if="quotations.length === 0" class="no-merchants">
                    暂无商家报价
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeSelectMerchantDialog">取消</el-button>
                <el-button type="primary" @click="confirmSelectMerchant">确认</el-button>
            </span>
        </el-dialog>

        <!-- 选择合作原因弹窗 -->
        <el-dialog title="选择合作原因" :visible.sync="cooperationReasonDialogVisible" width="400px"
            :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true">
            <div class="cooperation-reason-dialog">
                <el-radio-group v-model="selectedCooperationReason" class="reason-radio-group">
                    <el-radio v-for="reason in cooperationReasons" :key="reason.aid" :label="reason.aid">
                        {{ reason.name }}
                    </el-radio>
                </el-radio-group>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeCooperationReasonDialog">取消</el-button>
                <el-button type="primary" @click="confirmCooperationReason">确认</el-button>
            </span>
        </el-dialog>

        <!-- 二轮比价记录弹窗 -->
        <el-dialog title="二轮比价记录" :visible.sync="secondComparisonDialogVisible" width="800px"
            :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true">
            <div class="second-comparison-dialog">
                <el-table :data="secondComparisonRecords" style="width: 100%">
                    <el-table-column label="序号" width="80">
                        <template slot-scope="scope">
                            {{ scope.$index + 1 }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="store_name" label="店铺名称" width="180"></el-table-column>
                    <el-table-column prop="fahuodi" label="发货地" width="150"></el-table-column>
                    <el-table-column label="距离 (km)" width="120">
                        <template slot-scope="scope">{{ scope.row.distance_km }}</template>
                    </el-table-column>
                    <el-table-column label="综合报价 (元)" width="150">
                        <template slot-scope="scope">{{ scope.row.total_amount }}</template>
                    </el-table-column>
                    <el-table-column prop="create_time" label="报价时间" width="180"></el-table-column>
                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <a href="#" class="detail-link" @click="viewQuotationDetail(scope.row)">报价明细</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeSecondComparisonDialog">关闭</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
export default {
    name: 'PurchasesDetail',
    data() {
        return {
            // 采购详情数据
            purchaseDetail: {
                address_info: {
                    real_name: '',
                    mobile: '',
                    detail: '',
                },
                invoice_info: {
                    username: '',
                    email: '',
                    mobile: '',
                    tax_number: '',
                }
            },

            locationInfo: {},

            sort: '1',
            // 弹窗相关数据
            dialogVisible: false,
            currentQuotation: null,
            // 采购标题弹窗
            titleDialogVisible: false,
            // 采购商品弹窗
            goodsDialogVisible: false,
            // 采购商品数据
            purchaseGoods: [],
            // 收货人信息弹窗
            receiverInfoDialogVisible: false,
            // 开票信息弹窗
            invoiceDialogVisible: false,
            // 选择商家合作弹窗
            selectMerchantDialogVisible: false,
            // 选中的商家
            selectedMerchant: null,
            // 选择合作原因弹窗
            cooperationReasonDialogVisible: false,
            // 合作原因选项
            cooperationReasons: [
                { value: '1', label: '价格最优惠' },
                { value: '2', label: '商家态度好' },
                { value: '3', label: '发货速度快' },
                { value: '4', label: '商品质量好' }
            ],
            // 选中的合作原因
            selectedCooperationReason: '1',
            total_amount: 0,
            // 报价列表数据
            quotations: [],
            // 二轮比价记录弹窗
            secondComparisonDialogVisible: false,
            // 二轮比价记录数据
            secondComparisonRecords: [],

            shangjiaAidList: []
        }
    },
    mounted() {
        try {
            const locationInfoStr = localStorage.getItem('locationInfo');
            this.locationInfo = locationInfoStr ? JSON.parse(locationInfoStr) : {};
        } catch (error) {
            console.error('解析 locationInfo 失败:', error);
            this.locationInfo = {};
        }

        this.getMyPurchaseDetail();
    },
    methods: {
        downloadImage(imgUrl, fileName = 'image.jpg') {
            // 创建a标签
            const link = document.createElement('a');
            // 设置图片链接
            link.href = imgUrl;
            // 设置下载文件名
            link.download = fileName;
            // 模拟点击
            link.click();
        },
        downloadInvoice() {
            this.downloadImage(this.purchaseDetail.invoice_img, '发票照片.jpg');
        },
        goBack() {
            this.$parent.currentComponent = 'PurchasesList'
        },

        // 跳转修改采购页面
        handleEditOrder(order, is_new) {
            console.log(1234);

            this.$router.push({
                path: 'FabuCaigou',
                query: {
                    aid: order.aid,
                    is_new: is_new
                }
            });
        },


        // 处理结束采购订单
        handleCaigouOrder(order) {
            this.$confirm('确定要结束采购吗？', '结束采购', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.endPurchase(order.aid);
            }).catch(() => {
                this.$message.info('已取消');
            });
        },

        // 处理删除订单
        handleDeleteOrder(order) {
            this.$confirm('确定要删除此订单吗？', '删除订单', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteOrder(order.aid);
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },

        // 查看报价明细
        viewQuotationDetail(quotation) {
            this.currentQuotation = quotation;
            this.total_amount = quotation.total_amount;
            this.dialogVisible = true;
            console.log(quotation);
        },

        // 关闭弹窗
        closeDialog() {
            this.dialogVisible = false;
            this.currentQuotation = null;
        },

        // 打开采购标题弹窗
        openTitleDialog() {
            this.titleDialogVisible = true;
        },
        // 关闭采购标题弹窗
        closeTitleDialog() {
            this.titleDialogVisible = false;
        },
        // 打开采购商品弹窗
        openGoodsDialog() {
            this.goodsDialogVisible = true;
        },
        // 关闭采购商品弹窗
        closeGoodsDialog() {
            this.goodsDialogVisible = false;
        },
        // 打开收货人信息弹窗
        openReceiverInfoDialog() {
            this.receiverInfoDialogVisible = true;
        },
        // 关闭收货人信息弹窗
        closeReceiverInfoDialog() {
            this.receiverInfoDialogVisible = false;
        },
        // 打开开票信息弹窗
        openInvoiceDialog() {
            this.invoiceDialogVisible = true;
        },
        // 关闭开票信息弹窗
        closeInvoiceDialog() {
            this.invoiceDialogVisible = false;
        },
        // 计算合计金额
        calculateTotal() {
            if (!this.currentQuotation || !this.currentQuotation.child) return 0;
            return this.currentQuotation.child.reduce((total, item) => {
                return total + (item.platformTotal || 0);
            }, 0);
        },
        // 结束采购
        endPurchase(aid) {
            // console.log('结束采购');
            this.$dapi.endPurchase({
                aid: aid
            }).then(res => {
                this.$message.success('结束采购成功');
                // 返回列表页面
                // this.$parent.handleComponentChange('PurchasesList');
                this.getMyPurchaseDetail();
            }).catch(err => {
                this.$message.error('结束采购失败');
            });
        },

        // 删除订单
        deleteOrder(aid) {
            // console.log('删除订单');
            this.$dapi.deleteCaigouOrder({
                aid: aid
            }).then(res => {
                this.$message.success('删除订单成功');
                // 返回列表页面
                this.goBack()
            }).catch(err => {
                this.$message.error('删除订单失败');
            });
        },

        // 修改采购
        editPurchase() {
            console.log('修改采购');
        },
        // 选择商家询价
        selectMerchantForInquiry() {
            console.log('选择商家询价');
            if (this.shangjiaAidList.length == 0) {
                this.$message.error('请选择至少一个商家')
                return
            }
            let data = {
                aid: this.purchaseDetail.aid,
                choose_ids: this.shangjiaAidList.toString()
            }
            console.log(data);
            if (this.purchaseDetail.status == 1) {
                // 一轮询价
                this.$dapi.submitFirstInquiry(data).then(res => {
                    this.$message.success('选择商家询价成功');
                    // 返回列表页面
                    this.getMyPurchaseDetail();
                }).catch(err => {
                    this.$message.error('选择商家询价失败');
                });
            } else if (this.purchaseDetail.status == 2) {
                // 二轮询价
                this.$dapi.submitSecondInquiry(data).then(res => {
                    this.$message.success('选择商家询价成功');
                    // 返回列表页面
                    this.getMyPurchaseDetail();
                }).catch(err => {
                    this.$message.error('选择商家询价失败');
                });
            }

        },


        // 获取采购详情
        getMyPurchaseDetail() {
            // 从父组件获取订单ID
            const purchaseId = this.$parent.componentParams ? this.$parent.componentParams.purchaseId : '';
            if (!purchaseId) {
                this.$message.error('获取采购订单失败');
                return;
            }
            this.$api.getMyPurchaseDetail({
                aid: purchaseId
            }).then(res => {
                this.purchaseDetail = res;
                this.purchaseGoods = res.goods_list || [];
                this.getSellerOffer()
            })
        },

        // 获取商家报价/配载信息
        getSellerOffer() {
            // 从父组件获取订单ID
            const purchaseId = this.$parent.componentParams ? this.$parent.componentParams.purchaseId : '';
            if (!purchaseId) {
                this.$message.error('获取采购订单失败');
                return;
            }
            this.$api.getSellerOffer({
                aid: purchaseId,
                lat: this.locationInfo.lat ? this.locationInfo.lat : '',
                lng: this.locationInfo.lng ? this.locationInfo.lng : '',
                sort: this.sort
            }).then(res => {
                this.quotations = res;

                console.log(this.quotations, '22222');
            })
        },

        // 切换排序
        changeSort(sort) {
            this.sort = sort;
            this.getSellerOffer();
        },
        // 处理表格选择
        handleSelectionChange(selection) {
            // 清空数组
            this.shangjiaAidList = [];
            // 遍历选中的行，将店铺id添加到数组
            selection.forEach(item => {
                this.shangjiaAidList.push(item.aid);
            });
            console.log('选中的店铺id:', this.shangjiaAidList);
        },
        // 打开选择商家合作弹窗
        openSelectMerchantDialog() {
            this.selectMerchantDialogVisible = true;
            this.selectedMerchant = null;
        },
        // 关闭选择商家合作弹窗
        closeSelectMerchantDialog() {
            this.selectMerchantDialogVisible = false;
            this.selectedMerchant = null;
        },
        // 选择商家
        selectMerchant(merchant) {
            this.selectedMerchant = merchant;
        },
        // 确认选择商家合作
        confirmSelectMerchant() {
            if (!this.selectedMerchant) {
                this.$message.warning('请选择一个商家');
                return;
            }
            // 调用选择商家合作的方法
            this.selectMerchantForCooperation(this.selectedMerchant);
            this.closeSelectMerchantDialog();
        },
        // 选择商家合作
        selectMerchantForCooperation(merchant) {
            console.log('选择商家合作:', merchant.aid);
            this.hezuoShangjiaAid = merchant.aid
            // 打开合作原因弹窗
            this.getCooperationReasons()
            this.cooperationReasonDialogVisible = true;
        },
        // 关闭合作原因弹窗
        closeCooperationReasonDialog() {
            this.cooperationReasonDialogVisible = false;
            this.selectedCooperationReason = '';
        },
        // 确认选择合作原因
        confirmCooperationReason() {
            console.log('选中的合作原因:', this.selectedCooperationReason);
            this.hezuoAid = this.selectedCooperationReason
            // 这里可以添加调用API的代码
            this.submitSecondComparison()
            // this.$message.success('选择商家合作成功');
            this.closeCooperationReasonDialog();
        },
        // 打开二轮比价记录弹窗
        openSecondComparisonDialog() {
            this.secondComparisonDialogVisible = true;
            this.getSecondComparisonRecords()
        },
        // 关闭二轮比价记录弹窗
        closeSecondComparisonDialog() {
            this.secondComparisonDialogVisible = false;
        },

        // 获取合作原因
        getCooperationReasons() {
            this.$api.getCooperationReasons().then(res => {
                this.cooperationReasons = res;
            })
        },

        // 二轮比价提交
        submitSecondComparison() {
            let data = {
                aid: this.purchaseDetail.aid,
                choose_ids: this.hezuoShangjiaAid,
                hezuo_id: this.hezuoAid
            }
            this.$api.submitSecondComparison(data).then(res => {
                this.$message.success('选择商家合作成功');
                this.getMyPurchaseDetail()
                this.closeCooperationReasonDialog();
            })
        },

        // 配载延迟申请
        tongyiFn(type) {
            let data = {
                aid: this.purchaseDetail.aid,
                type: type
            }
            this.$api.applyLoadingDelay(data).then(res => {
                this.$message.success('已处理');
                this.getMyPurchaseDetail()
                // this.closeDelayDialog();
            })
        },

        // 获取二轮比价记录
        getSecondComparisonRecords() {
            let data = {
                aid: this.purchaseDetail.aid
            }
            this.$api.getSecondComparisonRecords(data).then(res => {
                this.secondComparisonRecords = res;
                // this.closeSecondComparisonDialog();
            })
        },

        // 申请开票
        applyInvoice() {
            let data = {
                aid: this.purchaseDetail.aid
            }
            this.$api.applyInvoice(data).then(res => {
                this.$message.success('申请开票成功');
                this.getMyPurchaseDetail()
            }).catch(err => {
                this.$message.error(err);
            })
        },
    }
}
</script>

<style scoped>
/* 基础样式 */
.purchases-detail-container {
    background-color: #F3F3F3;
    padding: 20px;
    min-height: 100vh;
}

/* 第一个板块：采购详情 */
.purchases-detail-section {
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* 第二个板块：商家报价和底部操作 */
.purchases-quotation-section {
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* 通用部分标题 */
.section-title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eaeaea;
}

.flex-center {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.title-icon {
    color: #286CED;
    font-size: 20px;
    font-weight: bold;
    margin-right: 8px;
}

.certificate-image {
    width: 60px;
    height: 60px;
}

.title-text {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

/* 采购详情部分 */
.detail-section {
    margin-bottom: 10px;
}

.purchase-info {
    display: flex;
    flex-direction: column;
    align-items: start;
    background-color: #f5f7fa;
    border-radius: 8px;
    padding: 20px;
}

.info-item {
    /* margin-bottom: 10px; */
}

.info-label {
    color: #666;
    margin-right: 10px;
    font-weight: 400;
    font-size: 14px;
}

.info-value {
    color: #333;
    font-weight: 500;
    font-weight: 400;
    font-size: 14px;
}

.status-section {
    margin: 15px 0;
    display: flex;
    flex-direction: column;
    align-items: start;
}

.status-section-box {
    display: flex;
    align-items: center;
}

.status-tag {
    color: #286CED;
    font-weight: 500;
    margin-right: 15px;
}

.countdown {
    color: #ff9800;
    margin-right: 15px;
}

.status-desc {
    color: #666;
    margin-top: 8px;
    font-weight: 400;
    font-size: 12px;
}

.action-buttons {
    display: flex;
    gap: 10px;
    /* margin-top: 20px; */
    justify-content: right;
    width: 100%;
}

/* 配载延迟申请样式 */
.loading-delay-section {
    margin-top: 20px;
    padding: 15px;
    /* background-color: #f5f7fa; */
    /* border-radius: 8px; */
    /* border: 1px solid #e4e7ed;
    width: 100%; */
}

.delay-status {
    margin-bottom: 15px;
}

.delay-tag {
    display: inline-block;
    padding: 2px 8px;
    background-color: #409EFF;
    color: #fff;
    font-size: 12px;
    border-radius: 4px;
    margin-right: 10px;
}

.delay-countdown {
    color: #606266;
    font-size: 14px;
}

.delay-reason {
    margin-bottom: 15px;
}

.delay-reason-title {
    color: #303133;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
}

.delay-reason-content {
    color: #606266;
    font-size: 14px;
    line-height: 1.5;
}

.delay-actions {
    text-align: left;
}

.reject-delay {
    margin-right: 10px;
}

.end-purchase {
    background-color: #fff;
    border-color: #dcdfe6;
    color: #606266;
}

.edit-purchase {
    background-color: #286CED;
    border-color: #286CED;
    color: #fff;
}

/* 商家报价部分 */
.quotation-section {
    margin-bottom: 20px;
}

.sort-options {
    margin-left: auto;
    display: flex;
    gap: 20px;
}

.sort-item {
    font-size: 14px;
    color: #666666;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
}

.sort-item.active {
    font-weight: bold;
    font-size: 14px;
    color: #FF9735;
    /* background-color: #ecf5ff; */
}

.quotation-table {
    border: 1px solid #eaeaea;
    border-radius: 8px;
    overflow: hidden;
}

/* 自定义 el-table 样式 */
::v-deep .el-table th {
    background-color: #f5f7fa;
    font-weight: 600;
    color: #333;
}

::v-deep .el-table tr:hover {
    background-color: #f9f9f9;
}

::v-deep .el-table .cell {
    font-size: 14px;
}

.detail-link {
    color: #153674;
    text-decoration: none;
    font-size: 12px;
}

.detail-link:hover {
    text-decoration: underline;
}

.table-note {
    padding: 15px;
    background-color: #f5f7fa;
    font-size: 12px;
    color: #666;
    text-align: center;
}

/* 底部操作按钮 */
.bottom-buttons {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    padding-top: 20px;
    border-top: 1px solid #eaeaea;
}

.info-button {
    background-color: #fff;
    border-color: #dcdfe6;
    color: #606266;
}

.select-button {
    background-color: #286CED;
    border-color: #286CED;
    color: #fff;
}

/* 响应式设计 */
@media (max-width: 1200px) {
    .quotation-table {
        overflow-x: auto;
    }

    .quotation-table table {
        min-width: 1000px;
    }
}

@media (max-width: 768px) {
    .purchases-detail-container {
        padding: 10px;
    }

    .purchases-detail-section,
    .purchases-quotation-section {
        padding: 15px;
    }

    .section-title {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .sort-options {
        margin-left: 0;
    }

    .action-buttons,
    .bottom-buttons {
        flex-wrap: wrap;
    }

    .bottom-buttons {
        justify-content: center;
    }
}

/* 配载明细弹窗样式 */
.loading-detail-dialog {
    padding: 10px 0;
}

.total-row {
    display: flex;
    justify-content: flex-end;
    align-items: self-end;
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid #eaeaea;
}

.total-label {
    font-weight: 600;
    margin-right: 40px;
    color: #333;
}

.total-amount {
    font-weight: 600;
    color: #333;
}

.certificate-link {
    color: #153674;
    text-decoration: none;
}

.certificate-link:hover {
    text-decoration: underline;
}

/* 采购标题弹窗样式 */
.title-dialog-content {
    padding: 20px 0;
    text-align: left;
}

.title-item h3 {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 20px;
    line-height: 1.5;
}

.requirement-item {
    margin-bottom: 20px;
}

.requirement-item p {
    font-size: 14px;
    line-height: 1.6;
    color: #333;
}

.settlement-item p {
    font-size: 14px;
    line-height: 1.6;
    color: #333;
}

/* 收货人信息弹窗样式 */
.receiver-info-content {
    padding: 20px 0;
    text-align: left;
}

.receiver-info-content p {
    font-size: 14px;
    line-height: 1.8;
    color: #333;
    margin-bottom: 10px;
}

/* 开票信息弹窗样式 */
.invoice-info-content {
    padding: 20px 0;
}

.invoice-header {
    margin-bottom: 20px;
    text-align: left;
}

.invoice-header p {
    font-size: 14px;
    line-height: 1.8;
    color: #333;
    margin-bottom: 10px;
}

.invoice-type {
    display: inline-block;
    padding: 2px 8px;
    background-color: #ff9800;
    color: #fff;
    font-size: 12px;
    font-weight: normal;
    margin-left: 10px;
    border-radius: 4px;
}

.invoice-image {
    text-align: center;
    margin-top: 20px;
}

.invoice-img {
    max-width: 100%;
    height: auto;
    border: 1px solid #eaeaea;
}

/* 选择商家合作弹窗样式 */
.select-merchant-dialog {
    max-height: 400px;
    overflow-y: auto;
}

.merchant-radio-group {
    width: 100%;
}

.merchant-radio {
    width: 100%;
    display: flex;
    align-items: center;

}

.merchant-item {
    text-align: left;
    padding: 15px;
    border: 1px solid #eaeaea;
    border-radius: 8px;
    margin-bottom: 10px;
    transition: all 0.3s ease;
    width: 650px;
}

.merchant-item:hover {
    border-color: #409EFF;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.merchant-name {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
}

.merchant-details {
    font-size: 14px;
    color: #666;
}

.merchant-details span {
    margin-right: 20px;
    display: inline-block;
    margin-bottom: 5px;
}

.no-merchants {
    text-align: center;
    padding: 40px 0;
    color: #999;
    font-size: 14px;
}

/* 选择合作原因弹窗样式 */
.cooperation-reason-dialog {
    padding: 20px 0;
}

.reason-radio-group {
    width: 100%;
    text-align: left;
}

.reason-radio-group .el-radio {
    display: block;
    margin-bottom: 15px;
    font-size: 14px;
    color: #333;
}

/* 二轮比价记录弹窗样式 */
.second-comparison-dialog {
    padding: 10px 0;
}

.delay-info {
    text-align: left;
}

/* 弹窗底部按钮 */
.dialog-footer {
    text-align: center;
}

/* 签名和装货图片样式 */
.signature-and-loading {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 20px;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.signature-section {
    /* margin-bottom: 20px; */
    width: 50%;
}

.loading-photo-section {
    /* margin-top: 20px; */
    width: 40%;
    margin-left: 40px;
}

.section-title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}

.title-icon {
    color: #286CED;
    font-size: 20px;
    font-weight: bold;
    margin-right: 8px;
}

.title-text {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.signature-list {
    display: flex;
    gap: 40px;
    height: 150px;
}

.signature-item {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.signature-image {
    width: 230px;
    height: 100px;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
}

.signature-image .signature-image-el {
    width: 100%;
    height: 100%;
}

.signature-label {
    font-size: 14px;
    color: #666;
}

.loading-photo {
    width: 150px;
    height: 150px;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
}

.loading-photo .signature-image-el {
    max-width: 100%;
    max-height: 100%;
}
</style>